import React, { useState } from 'react';
import { getI18n } from 'react-i18next';

import { Button, Cascader, Tooltip } from 'antd';
import { EllipsisOutlined } from '@ant-design/icons';
import { FiEdit } from 'react-icons/fi';

import { withRouter } from 'react-router';
import { pathTo } from '../../../Routes';
import ConfirmationModal from '../../../elements/components/ConfirmationModal';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faTrashCan } from '@fortawesome/free-regular-svg-icons';
import QueryString from '../../../../../lib/QueryString';

const confirmTexts = {
  title: getI18n().t('learning_admin_module_serie_action_delete_title'),
  description: null,
  leaveText: getI18n().t('learning_admin_module_serie_action_delete_leave'),
  saveText: getI18n().t('learning_admin_module_serie_action_delete_save'),
};

const LearningAdminModuleSeriesListAction = ({
  row,
  partnershipId,
  editScreen,
  history,
  handleDelete,
  view,
  activeKey,
  ...props
}) => {
  const [confirmationModalOpen, setConfirmationModalOpen] = useState(false);

  const { id, public_status } = row;

  const menuItems = [
    {
      label: (
        <span className='module-serie-table-menu-item'>
          <FiEdit />
          <span className='text-align'>
            {getI18n().t('learning_admin_module_serie_action_edit')}
          </span>
        </span>
      ),
      value: 1,
    },
    {
      label:
        public_status !== 3 ? (
          <Tooltip
            placement='left'
            title={getI18n().t('learning_module_series_message_info_delete')}
            arrowPointAtCenter={true}
          >
            <span
              className='module-serie-table-menu-item'
              style={{ color: 'gray' }}
            >
              <FontAwesomeIcon icon={faTrashCan} size='2x' />
              <span className='text-align'>
                {getI18n().t('learning_admin_module_serie_action_delete')}
              </span>
            </span>
          </Tooltip>
        ) : (
          <span
            className='module-serie-table-menu-item'
            style={{ color: '#F44336' }}
          >
            <FontAwesomeIcon icon={faTrashCan} size='2x' />
            <span className='text-align'>
              {getI18n().t('learning_admin_module_serie_action_delete')}
            </span>
          </span>
        ),
      value: 2,
      disabled: public_status !== 3,
    },
  ];

  const onChange = (item) => {
    const value = item[0];

    if (value === 1) {
      history.push(
        QueryString.append(
          pathTo(editScreen, {
            id_partnership: partnershipId,
            id: id,
          }),
          { view, key: activeKey }
        )
      );
    } else if (value === 2) {
      setConfirmationModalOpen(true);
    }
  };

  const handleConfirmLeave = () => {
    setConfirmationModalOpen(false);
  };

  const handleConfirmDelete = () => {
    setConfirmationModalOpen(false);
    handleDelete();
  };

  return (
    <span onClick={(e) => e.stopPropagation()} className='actions'>
      <Cascader
        options={menuItems}
        onChange={onChange}
        dropdownMenuColumnStyle={{ height: '32px' }}
        defaultValue={[]}
        value={[]}
      >
        <Button
          style={{ verticalAlign: '2px' }}
          icon={<EllipsisOutlined />}
          type='text'
          onClick={(e) => e.stopPropagation()}
        ></Button>
      </Cascader>
      <ConfirmationModal
        texts={confirmTexts}
        openConfirmationModal={confirmationModalOpen}
        onLeaveConfirmation={handleConfirmDelete}
        onSaveConfirmation={handleConfirmLeave}
        onCancel={handleConfirmLeave}
        setConfirmationModalOpen={setConfirmationModalOpen}
      />
    </span>
  );
};

export default withRouter(LearningAdminModuleSeriesListAction);
